<template>
  <div class="trial-guarantee">
    <h2 class="trial-guarantee__title" v-html="$t('oldTranslations.trial.guarantee.title')" />
    <p
      class="trial-guarantee__text"
      v-html="$t('oldTranslations.trial.guarantee.paragraph_1')"
    />
    <p
      class="trial-guarantee__text"
      v-html="$t('oldTranslations.trial.guarantee.paragraph_2')"
    />
    <ul
      class="trial-guarantee__list"
    >
      <li class="trial-guarantee__item">
        <i-svg icon="icon_checked" fill="#5773D6" />
        <p v-html="$t('oldTranslations.trial.guarantee.list.item1')" />
      </li>
      <li class="trial-guarantee__item">
        <i-svg icon="icon_checked" fill="#5773D6" />
        <p v-html="$t('oldTranslations.trial.guarantee.list.item2')" />
      </li>
    </ul>
    <base-button
      type="blue"
      with-shadow rounded="full"
      class="trial-guarantee__cta"
      @click="handleCta"
    >
      {{ $t('oldTranslations.trial.guarantee.cta') }}
    </base-button>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['action']);
const { mixpanelTrack } = useMixpanel();
const { toggleComponent } = useModals();

mixpanelTrack('Guarantee Screen Shown');
function handleCta() {
  emit('action');
  toggleComponent();
}
</script>

<style lang="scss" scoped>
.trial-guarantee {
  display: flex;
  flex-direction: column;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: $white;
  padding: 24px 23px 48px;
  width: 100%;
  max-width: 311px;
  margin: 0 auto;
  z-index: 10;
  border-radius: 20px;

  &__title {
    text-align: center;
    font-family: $primary-fonts;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 135%; /* 27px */
    margin-bottom: 24px;
  }

  &__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    margin-bottom: 16px;

    & :deep(.bold) {
      font-weight: 600;
    }

    & :deep(.blue) {
      font-weight: 600;
    }
  }

  &__list {
    margin-top: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 16px;

    margin-bottom: 32px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 20px;

    & svg {
      flex-shrink: 0;
    }

    & p {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 21px */

      & :deep(.bold) {
        font-weight: 600;
      }
    }
  }

  &__cta {

  }

  &__footer {
    margin-top: 32px;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 150%; /* 18px */

    & a {
      font-weight: 600;
      color: $blue;
    }
  }
}
</style>
